import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { APP_BASE_HREF } from '@angular/common';
import { Constants } from '../../shared/Constants';

@Injectable()
export class TasksService {

    constructor(private http: HttpClient) {

    }

    getTasksOfProject(idProject, name) {
        let headers = new HttpHeaders();
        headers = headers.set('Content-type', 'application/json');
        headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
        return this.http.get(Constants.URL_BACKEND + '/tasks/findByProject/' + idProject + '?name=' + name, { headers: headers });
    }

    getAllTask() {
        let headers = new HttpHeaders();
        headers = headers.set('Content-type', 'application/json');
        headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
        return this.http.get(Constants.URL_BACKEND + '/tasks/', { headers: headers });
    }

    getAllArchivedTask() {
        let headers = new HttpHeaders();
        headers = headers.set('Content-type', 'application/json');
        headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
        return this.http.get(Constants.URL_BACKEND + '/tasks/archived', { headers: headers });

    }

    updateTask(taskId, task) {
        let headers = new HttpHeaders();
        headers = headers.set('Content-type', 'application/json');
        headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
        return this.http.put(Constants.URL_BACKEND + '/tasks/' + taskId, { data: task }, { headers: headers });

    }
    createTask(task) {
        let headers = new HttpHeaders();
        headers = headers.set('Content-type', 'application/json');
        headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
        return this.http.post(Constants.URL_BACKEND + '/tasks/', { data: task }, { headers: headers });

    }

    createTasksByProject(arrayTasks, idProject) {
        let headers = new HttpHeaders();
        headers = headers.set('Content-type', 'application/json');
        headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
        return this.http.post(Constants.URL_BACKEND +
            '/tasks/assignMultiple', { taskArray: arrayTasks, idProject: idProject }, { headers: headers });

    }

    getDetailedTasksByProject(idProject) {
        let headers = new HttpHeaders();
        headers = headers.set('Content-type', 'application/json');
        headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
        return this.http.get(Constants.URL_BACKEND + '/tasks/detailedTasksByProject/' + idProject, { headers: headers });
    }

    getAllCommonTasks() {
        let headers = new HttpHeaders();
        headers = headers.set('Content-type', 'application/json');
        headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
        return this.http.get(Constants.URL_BACKEND + '/tasks/listAllCommonTasks', { headers: headers });
    }

    getAllTasksbyProjectId(idProject) {
        let headers = new HttpHeaders();
        headers = headers.set('Content-type', 'application/json');
        headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
        return this.http.get(Constants.URL_BACKEND + '/tasks/byProject/' + idProject, { headers: headers });
    }

    getListTaskByUserBetweenDates(startDate, endDate) {
        let headers = new HttpHeaders();
        headers = headers.set('Content-type', 'application/json');
        headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
        const params = new HttpParams().set('start_date', startDate).append('end_date', endDate);
        return this.http.get(Constants.URL_BACKEND + '/tasks/ListTaskByUserBetweenDates', { headers: headers, params: params });
    }
    tasksByInternalWorkOrder(idInternalWorkOrder) {
        let headers = new HttpHeaders();
        headers = headers.set('Content-type', 'application/json');
        headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
        return this.http.get(Constants.URL_BACKEND + '/tasks/TasksByInternalWorkOrder/' + idInternalWorkOrder, { headers: headers });
    }

    updateTasksByInternalWorkOrder(arrayTasks, idInternalWorkOrder) {
        let headers = new HttpHeaders();
        headers = headers.set('Content-type', 'application/json');
        headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
        return this.http.post(Constants.URL_BACKEND + '/tasks/register-tasks-by-internal-work-order/',
         { arrayOfTasks: arrayTasks, idInternalWorkOrder: idInternalWorkOrder }, { headers: headers });
    }

}



// WEBPACK FOOTER //
// ./src/app/system/services/tasks.service.ts